
import React, { Fragment, useState, useEffect } from 'react';
import {  Row, Col, Card, Button,Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { authHeader } from '../../utils/functions/CoreFunctions';
import { USER_DETAILS_URL } from '../../utils/APIEndpoints';
import API from '../../redux/actions/API';
import { getAlertToast  } from '../../utils/functions/CustomFunctions';
import Swal from 'sweetalert2';
import defaultAvatar from '../../assets/images/defaultImages/defaultAvatar.png';
import Loader from '../loader';

const View = (props) => {
    const { viewToggle, viewModal, userId } = props;
   const [userData, setUserData]  = useState({});
   const [loading, setLoading] = useState(false);
 
   //Get Dashboard Data
   const getUserData = async () => {
    setLoading(true);
    const options = {
        method : 'GET',
        url : USER_DETAILS_URL,
        headers: authHeader(),
        params: {userId}
    };
     try{
       const response = await API(options);
       const {status} = response.data;
       if(status === 'Success')
       {  
           setUserData(response.data);
       }
       }catch(error){
           if (error.response) {
           let { data } = error.response;
           Swal.fire(getAlertToast('error', data.message ));
           }
       }finally{
           setLoading(false);
       }
   }
 
    //Did Mount
    useEffect(() => {
      getUserData();
    }, []);  

    const closeBtn = <button type="button" className="btn-close" onClick={viewToggle} aria-label="Close"></button>;

    return (
            <Fragment>   
                 <Modal isOpen={viewModal} toggle={viewToggle} style={{maxWidth:'800px'}} backdrop="static">
                    <ModalHeader toggle={viewToggle} close={closeBtn}>Agency User Details</ModalHeader>
                    <ModalBody >      
            <Card body className="mt-5">
            {loading ? <Loader/>
                    :
                    <Fragment>
                    <Row>
                        <Col md={4}></Col>
                        <Col md={4}> <img className="uploadImg m-auto d-block" src={userData.profileImage || defaultAvatar} widht={100} height={100} alt="User profile"/></Col>
                        <Col md={4}></Col>
                    </Row>
                    <Row>
                    <Col sm="12" md={{ size: 6, offset: 3 }}>
                    <div className="kt-widget__content" style={{padding: '0'}}>
                    <div className="kt-widget__info mb-2">
                    <span className="kt-widget__label">First Name:</span>
                    <span className="kt-widget__data">{userData?.firstName}</span>
                    </div>
                    <div className="kt-widget__info mb-2">
                    <span className="kt-widget__label">Last Name:</span>
                    <span className="kt-widget__data">{userData.lastName}</span>
                    </div>
                    <div className="kt-widget__info mb-2">
                    <span className="kt-widget__label">Email:</span>
                    <span className="kt-widget__data">{userData.email}</span>
                    </div>
                    <div className="kt-widget__info mb-2">
                    <span className="kt-widget__label">Phone Number:</span>
                    <span className="kt-widget__data">(+1) {userData.phoneNumber}</span>
                    </div>
                    <div className="kt-widget__info mb-2">
                    <span className="kt-widget__label">Address:</span>
                    <span className="kt-widget__data">{userData.address}</span>
                    </div>
                    </div>

                    </Col>
                    </Row>
                    </Fragment>
                }
            </Card>  
            </ModalBody> 
                <ModalFooter>
                    <Button color="secondary" onClick={viewToggle}>Close</Button>
                </ModalFooter>
            </Modal>          
        </Fragment>
    );
}

export default View;
